import React, {useState} from 'react'
import FloatingVideos from './floating-videos'
import FixedVideoPage from './fixed-video-page'
import VideoFragments from './swiper-video-fragments'
import ListingVideos from './listing-videos'

export default props => {
    const {videos, showFloating} = props
    const [showFullVideo, setShowFullVideo] = useState(false)
    const [videoIndex, setVideoIndex] = useState(0)
    const [showFloatingVideo, setShowFloatingVideo] = useState(true)
    const [fragmentVideoIndex, setFragmentVideoIndex] = useState(0)
    const [showVideoList, setShowVideoList] = useState(false)

    const floatingVideoClickHandle = (index, video) => {
        setFragmentVideoIndex(index)
        setShowFullVideo(true)
    }

    const listVideoClickHandle = (index, video) => {
        setFragmentVideoIndex(index)
        setShowFullVideo(true)
    }




    return <>
        {
            showFloatingVideo && showFloating && <FloatingVideos videoIndex={videoIndex} onClose={() => setShowFloatingVideo(false)} floatingVideoClickHandle={floatingVideoClickHandle} videos={videos}/>
        }

        <VideoFragments viewMoreHandle={() => setShowVideoList(true)} floatingVideoClickHandle={floatingVideoClickHandle} videos={videos} videoIndex={videoIndex} positionChange={index => setVideoIndex(index)} />

        <FixedVideoPage videos={videos} changeVideoIndex={setFragmentVideoIndex} videoIndex={fragmentVideoIndex} show={showFullVideo} onClose={() => setShowFullVideo(false)}/>
    
        <ListingVideos show={showVideoList} onClose={() => setShowVideoList(false)} videos={videos} listVideoClickHandle={listVideoClickHandle}/>
    </>
}